import { baseSeriesMark } from "../base/constant";

export const roseSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    rose: {
        name: "rose",
        type: "arc"
    }
});
//# sourceMappingURL=constant.js.map
